// General imports, like internal and external libraries
import Loading from 'atoms/Loading'
import { Suspense } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import './index.css'

// Containers (Every page of our module)
import TradingPartnerList from './containers/TradingPartnerList'
import ConversionCodeDetail from './containers/ConversionCodeDetail'
import TradingPartnerDetail from './containers/TradingPartnerDetails'

const TradingPartnerIndex = () => {
  const { path } = useRouteMatch()

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={path}>
          <TradingPartnerList />
        </Route>
        <Route path={`${path}/:id`} exact>
          <TradingPartnerDetail />
        </Route>
        <Route path={`${path}/:id/conversion-codes`} exact>
          <ConversionCodeDetail />
        </Route>
      </Switch>
    </Suspense>
  )
}

export default TradingPartnerIndex
